class RecipeSection extends HTMLElement {
  connectedCallback() {
    this.basePortions = Math.round(parseFloat(this.dataset.basePortions) || 1);
    this.currentPortions = this.basePortions;

    this.decBtn = this.querySelector('.rezept-details__scaler-dec');
    this.incBtn = this.querySelector('.rezept-details__scaler-inc');
    this.countEl = this.querySelector('.rezept-details__scaler-count');

    this.decBtn?.addEventListener('click', () => this.changePortions(-1));
    this.incBtn?.addEventListener('click', () => this.changePortions(1));

    this.formatPreparationSteps();
    this.injectStepNumbers();
  }

  injectStepNumbers() {
    const items = this.querySelectorAll('.rezept-details__preparation ol > li');
    items.forEach((li, index) => {
      if (li.querySelector('.rezept-step__number')) return;
      const numDiv = document.createElement('div');
      numDiv.className = 'rezept-step__number';
      numDiv.textContent = index + 1;
      li.prepend(numDiv);
      const content = document.createElement('div');
      content.className = 'rezept-step__content';
      Array.from(li.childNodes).forEach(node => {
        if (node !== numDiv) content.appendChild(node);
      });
      li.appendChild(content);
    });
  }

  formatPreparationSteps() {
    const container = this.querySelector('.rezept-details__preparation');
    if (!container || container.querySelector('ol')) return;

    const paragraphs = container.querySelectorAll('p');
    if (!paragraphs.length) return;

    const html = Array.from(paragraphs).map(p => p.innerHTML).join('<br>').replace(/&nbsp;/g, ' ');

    // Split by <strong>-wrapped step markers or bare keycap emojis (1️⃣ without <strong>)
    const parts = html.split(/(?=<strong>\s*\d[^\w<]*\s)|(?<!<strong>\s*)(?=\d\uFE0F?\u20E3)/);
    if (parts.length <= 1) return;

    // First part is intro (recipe title)
    const intro = parts[0].replace(/(<br\s*\/?>|\s)+$/g, '').trim();

    let ol = '';
    let tip = '';
    let stepNum = 0;

    // Helper: build one <li> from title + content string
    const addStep = (title, rawContent) => {
      let c = rawContent.replace(/^(<br\s*\/?>)+/g, '').replace(/(<br\s*\/?>)+$/g, '').trim();
      const lines = c.split(/<br\s*\/?>/).map(l => l.trim()).filter(Boolean);
      const html = lines.map(l => `<p>${l}</p>`).join('');
      if (!title && !html) return;
      stepNum++;
      ol += '<li>';
      ol += `<div class="rezept-step__number">${stepNum}</div>`;
      ol += '<div class="rezept-step__content">';
      if (title) ol += `<strong class="rezept-step__title">${title}</strong>`;
      if (html) ol += `<div class="rezept-step__text">${html}</div>`;
      ol += '</div>';
      ol += '</li>';
    };

    for (let i = 1; i < parts.length; i++) {
      let part = parts[i];

      // Extract tip section (📌) if present
      const tipIdx = Math.max(part.indexOf('<strong>📌'), part.indexOf('📌'));
      if (tipIdx >= 0) {
        tip = part.substring(tipIdx).replace(/(<br\s*\/?>|\s)+$/g, '').trim();
        part = part.substring(0, tipIdx);
      }

      // Title: rest of marker line, ends at </strong> (bold step) or <br> (bare keycap)
      const titleMatch = part.match(/^(?:<strong>\s*)?\d[^\p{L}<]*(.*?)(?:<\/strong>|<br\s*\/?>|$)/u);
      // Strip <strong> from title (e.g. "1️⃣ <strong>Title</strong>") – avoids unclosed tag bolding everything after
      const title = titleMatch ? titleMatch[1].replace(/<\/?strong>/g, '').trim() : '';
      addStep(title, titleMatch ? part.slice(titleMatch[0].length) : part);
    }

    let result = '';
    if (intro) result += `<p class="rezept-step__intro">${intro}</p>`;
    result += `<ol>${ol}</ol>`;
    if (tip) result += `<div class="rezept-step__tip">${tip}</div>`;

    paragraphs.forEach(p => p.remove());
    container.insertAdjacentHTML('beforeend', result);
  }

  changePortions(delta) {
    const next = this.currentPortions + delta;
    if (next < 1) return;
    this.currentPortions = next;
    if (this.countEl) this.countEl.textContent = next;
    this.updateAmounts();
  }

  updateAmounts() {
    const factor = this.currentPortions / this.basePortions;
    this.querySelectorAll('[data-base-amount]').forEach((el) => {
      const base = parseFloat(el.dataset.baseAmount);
      const scaled = base * factor;
      el.textContent = this.formatAmount(scaled);
    });
  }

  formatAmount(val) {
    const rounded = Math.round(val * 10) / 10;
    if (rounded === Math.floor(rounded)) return String(Math.round(rounded));
    return String(rounded).replace('.', ',');
  }

}

customElements.define('recipe-section', RecipeSection);
